import 'css-chunksrc/client/scenes/taskCompletion/form/styles.scss';export default {
  "form": "_form_oni95_1",
  "section": "_section_oni95_11",
  "freeDateCheckBox": "_freeDateCheckBox_oni95_29",
  "label": "_label_oni95_38"
};